<template>
    <v-app>
        <v-container fluid>
            <v-row v-if="$insertAccess($route.fullPath)">
                <v-col cols="12">
                    <v-card>
                        <v-card>
                            <v-card-title 
                                class="text-subtitle-1 bg-blue-grey-lighten-4 mb-0 pa-1" 
                            >
                                <v-icon class="me-1" size="small">mdi-account-multiple</v-icon>
                                Add Employee Form
                            </v-card-title>

                            <v-card-text>
                                <v-form @submit.prevent="submit" ref="addEmployee" id="addEmployee">
                                    
                                    <v-row class="py-2">

                                        <v-col lg="4" md="4" cols="12">  

                                            <v-text-field
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="code.value.value"
                                                :error-messages="code.errorMessage.value"
                                                autocomplete="off"
                                            >
                                                <template #label>
                                                    Employee Code
                                                </template>
                                            </v-text-field> 
                                            
                                            <v-text-field
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="name.value.value"
                                                :error-messages="name.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Name
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field>

                                            <v-text-field
                                                label ="Name (Bangla)"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="name_bangla.value.value"
                                                :error-messages="name_bangla.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-text-field>

                                            <v-autocomplete
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="department_id.value.value"
                                                :items="getHrmDepartmentList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="department_id.errorMessage.value"
                                                :loading="loading"
                                                autocomplete="off"
                                                clearable
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    Department
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>
                                            <v-autocomplete
                                                label="Branch"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="branch_id.value.value"
                                                :items="getBranchList"
                                                :item-title="(item) => `${item.name} - ${item?.company?.name}`"
                                                item-value="id"
                                                :error-messages="branch_id.errorMessage.value"
                                                :loading="loading"
                                                autocomplete="off"
                                                clearable
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    Branch
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="designation_id.value.value"
                                                :items="getHrmDesignationList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="designation_id.errorMessage.value"
                                                :loading="loading"
                                                autocomplete="off"
                                                clearable
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    Designation
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="hod_approve_employee_id.value.value"
                                                :items="getHrmEmployeeList"
                                                :item-title="(item) => `${item.name} - ${item.code || ''}`"
                                                item-value="id"
                                                :error-messages="hod_approve_employee_id.errorMessage.value"
                                                :loading="loading"
                                                autocomplete="off"
                                                clearable
                                                no-data-text="No employees found. Please ensure employees are created and active."
                                                placeholder="Select HOD Approver"
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    HOD Approver
                                                </template>
                                                <template #prepend-inner>
                                                    <v-icon size="small">mdi-account-check</v-icon>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="hr_approve_employee_id.value.value"
                                                :items="getHrmEmployeeList"
                                                :item-title="(item) => `${item.name} - ${item.code || ''}`"
                                                item-value="id"
                                                :error-messages="hr_approve_employee_id.errorMessage.value"
                                                :loading="loading"
                                                autocomplete="off"
                                                clearable
                                                no-data-text="No employees found. Please ensure employees are created and active."
                                                placeholder="Select HR Approver"
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    HR Approver
                                                </template>
                                                <template #prepend-inner>
                                                    <v-icon size="small">mdi-account-supervisor</v-icon>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="employee_type_id.value.value"
                                                :items="getHrmEmployeeTypeList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="employee_type_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    Employee Type
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-text-field
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="mobile.value.value"
                                                :error-messages="mobile.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Mobile No
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field>

                                            <v-text-field
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="email.value.value"
                                                :error-messages="email.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Email
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field> 


                                            <v-text-field
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="nid.value.value"
                                                :error-messages="nid.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    National ID
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field>

                                        </v-col>

                                        <v-col lg="4" md="4" cols="12">
                                            <v-text-field
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="father_name.value.value"
                                                :error-messages="father_name.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Father's / Husband's Name
                                                   
                                                </template> 
                                            </v-text-field>    

                                            <v-text-field
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="mother_name.value.value"
                                                :error-messages="mother_name.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Mother's Name
                                                    
                                                </template>
                                            </v-text-field>  

                                            <v-autocomplete
                                                label="Gender Type"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="gender_id.value.value"
                                                :items="getGenderType"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="gender_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    Gender Type
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-autocomplete
                                                label="Blood Group"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="blood_group_id.value.value"
                                                :items="getBloodGroup"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="blood_group_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                                             <v-autocomplete
                                                label="Religion"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="religion_id.value.value"
                                                :items="getHrmReligionList"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="religion_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            
                                                 :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    Religion
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-text-field
                                                label="Phone (Residence)"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="phone_residence.value.value"
                                                :error-messages="phone_residence.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-text-field>

                                            <v-text-field
                                                label="Phone (Office)"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="phone_office.value.value"
                                                :error-messages="phone_office.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-text-field> 

                                            <v-text-field
                                                label="Height (Optional)"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="height.value.value"
                                                :error-messages="height.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-text-field> 


                                            <v-text-field
                                                label="Weight (Optional)"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="weight.value.value"
                                                :error-messages="weight.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-text-field>

                                            <v-text-field
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="emergency_contact_person.value.value"
                                                :error-messages="emergency_contact_person.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Emergency Contact Person
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field>

                                            <v-text-field
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="emergency_contact_no.value.value"
                                                :error-messages="emergency_contact_no.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Emergency Contact No
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field>

                                            <v-text-field
                                                label="Card ID"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="card_id.value.value"
                                                :error-messages="card_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-text-field>

                                        </v-col>

                                        <v-col lg="4" md="4" cols="12">     
                                           <v-autocomplete
                                                label="User Tag"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="user_id.value.value"
                                                :items="getUserList"
                                                :item-title="(item) => `${item.full_name} - ${item.code}`"
                                                item-value="id"
                                                :error-messages="user_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            
                                               :menu-props="{ contentClass: 'my-custom-dropdown' }"
></v-autocomplete>

                                            <v-text-field
                                                label="Passport No (Optional)"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="passport_no.value.value"
                                                :error-messages="passport_no.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            ></v-text-field>  

                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="Date of Birth"
                                                density="compact"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="date_of_birth.value.value"
                                                :error-messages="date_of_birth.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Date of Birth
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-date-input>  

                                            <v-autocomplete
                                                label="Marital Status"
                                                variant="outlined"
                                                density="compact"
                                                bg-color="grey-lighten-4"
                                                v-model="marital_status_id.value.value"
                                                :items="getMaritalStatus"
                                                :item-title="(item) => `${item.name}`"
                                                item-value="id"
                                                :error-messages="marital_status_id.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            
                                                :menu-props="{ contentClass: 'my-custom-dropdown' }"
>
                                                <template #label>
                                                    Marital Status
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-autocomplete>

                                            <v-text-field
                                                label="Nationality"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="nationality.value.value"
                                                :error-messages="nationality.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Nationality
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-text-field> 

                                            <v-textarea
                                                label="Permanent Address"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                v-model="permanent_address.value.value"
                                                auto-grow
                                                :rows="1"
                                                :error-messages="permanent_address.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Permanent Address
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-textarea> 

                                            <v-date-input
                                                input-format="dd/mm/yyyy"
                                                label="Joining Date"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                prepend-icon=""
                                                prepend-inner-icon="mdi mdi-calendar-month"
                                                v-model="joining_date.value.value"
                                                :error-messages="joining_date.errorMessage.value"
                                                autocomplete="off"
                                                clearable
                                            >
                                                <template #label>
                                                    Joining Date
                                                    <span class="text-red-accent-4">*</span>
                                                </template>
                                            </v-date-input>


                                            <v-file-input
                                                v-model="selectedImage"
                                                label="Select an Image"
                                                accept="image/*"
                                                density="compact"
                                                variant="outlined"
                                                bg-color="grey-lighten-4"
                                                show-size
                                                @input="previewImage"                               
                                                @click:clear="clearImage"
                                                class="ellipsis-filename"
                                                title="image"
                                            >                                                                                                  
                                            </v-file-input>
                                            <div class="float-right">
                                                <v-img  :src="preview" cover  class="preview-image"></v-img>
                                            </div>

                                            <v-checkbox
                                                :true-value="1"
                                                :false-value="0"
                                                v-model="status.value.value"
                                                label="Active"
                                                color="primary"
                                            ></v-checkbox>  


                                            <input v-model="employee_id.value.value" type="hidden">
                                        </v-col>

                                    </v-row>

                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-layout class="justify-end">
                                        <v-btn class="bg-red" variant="flat" type="reset">Reset</v-btn>
                                            <v-btn 
                                                class="bg-brand w-15 ms-2"  
                                                variant="flat" 
                                                type="submit"
                                            >
                                            {{ buttonText }}
                                            </v-btn>
                                    </v-layout>
                                    </v-card-actions>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>
    </v-app>
</template>

<script>

import {useStore} from 'vuex';
import { useField, useForm } from 'vee-validate';
import * as yup from 'yup';
import { ref } from 'vue';
import { toast } from 'vue3-toastify';
import formattedDate from '@/plugins/dateFormatter';
import { useRouter } from 'vue-router';

export default {
        components: {
        },
        data: () => ({
            panel: [0],
            loading:false,
            errorMessages:'',
            visible: false,
            search: "",
            selectedImage: null,
            photo_imageFile:'',
            preview: '/src/assets/no_preview.png',
        }),
        
        watch: {
        },

        created(){
            this.loading = true;
            Promise.all([
                this.$store.getters.getHrmDepartmentList.length === 0 ? this.$store.dispatch('getHrmDepartmentList') : Promise.resolve(),
                this.$store.getters.getHrmDesignationList.length === 0 ? this.$store.dispatch('getHrmDesignationList') : Promise.resolve(),
                this.$store.getters.getHrmEmployeeTypeList.length === 0 ? this.$store.dispatch('getHrmEmployeeTypeList') : Promise.resolve(),
                this.$store.getters.getHrmBloodGroupList.length === 0 ? this.$store.dispatch('getHrmBloodGroupList') : Promise.resolve(),
                this.$store.getters.getHrmReligionList.length === 0 ? this.$store.dispatch('getHrmReligionList') : Promise.resolve(),
                this.$store.getters.getHrmMaritalStatusList.length === 0 ? this.$store.dispatch('getHrmMaritalStatusList') : Promise.resolve(),
                this.$store.getters.getHrmGenderList.length === 0 ? this.$store.dispatch('getHrmGenderList') : Promise.resolve(),
                this.$store.getters.getUsersList.length === 0 ? this.$store.dispatch('getUsersList') : Promise.resolve(),
                this.$store.getters.getHrmEmployeeList.length === 0 ? this.$store.dispatch('getHrmEmployeeList') : Promise.resolve()
            ]).then(() => {
                this.loading = false;
                // Debug: Check if employee list loaded
                const employeeCount = this.$store.getters.getHrmEmployeeList?.length || 0;
                if (employeeCount === 0) {
                    console.warn('Employee list is empty. Make sure employees exist in the system.');
                } else {
                    console.log(`Loaded ${employeeCount} employees for approver selection`);
                }
            }).catch((error) => {
                this.loading = false;
                console.error('Error loading data:', error);
            });
        },
        
        computed:{
            getHrmDepartmentList() {
                return this.$store.getters.getHrmDepartmentList;
            },
            getHrmDesignationList() {
                return this.$store.getters.getHrmDesignationList;
            },
            getBranchList() {
                console.log(this.$store.getters.getBranchList);
                return this.$store.getters.getBranchList;
            },

            getUserList() {
                return this.$store.getters.getUsersList;
            },

            getHrmEmployeeTypeList() {
                return this.$store.getters.getHrmEmployeeTypeList;
            },
            getGenderType() {
                return this.$store.getters.getHrmGenderList;
            },
            getBloodGroup() {
                return this.$store.getters.getHrmBloodGroupList;
            },
            getHrmReligionList() {
                return this.$store.getters.getHrmReligionList;
            },
            getMaritalStatus() {
                return this.$store.getters.getHrmMaritalStatusList;
            },
            getHrmEmployeeList() {
                const employees = this.$store.getters.getHrmEmployeeList || [];
                // Show all employees for approver selection (can be active or inactive)
                // If you want to filter only active, uncomment the line below
                // return employees.filter(emp => emp.status === 1 || emp.status === '1');
                return employees;
            }
        },
        methods: {
            previewImage: function(event) {
                this.selectedImage = event.target.files[0];
                const input = event.target;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    reader.onload = (e) => {
                    this.preview = e.target.result;
                    }
                    this.image = input.files[0];
                    reader.readAsDataURL(input.files[0]);
                }
                else {
                    this.preview = '/src/assets/no_preview.jpeg';
                }
            },
            clearImage() {
                this.preview = '/src/assets/no_preview.png';
            },
        },
        setup() {
            const { handleSubmit, resetForm} = useForm({
                validationSchema: yup.object({
                    name: yup.string().min(3).max(70).required().trim().label('Name'),
                    father_name: yup.string().max(70).nullable().trim().label('Father Name'),
                    mother_name: yup.string().max(70).nullable().trim().label('Mother Name'),
                    name_bangla: yup.string().max(70).trim().nullable().label('Name (Bangla)'),
                    phone_residence: yup.string().min(7).max(15).nullable().trim().label('Phone (Residence)'),
                    phone_office: yup.string().min(7).max(15).nullable().trim().label('Phone (Office)'),
                    height: yup.number().nullable().max(300).label('Height'),
                    weight: yup.number().nullable().max(500).label('Weight'),
                    date_of_birth: yup.date().required().label('Date of Birth'),
                    joining_date: yup.date().required().label('Joining Date'),
                    emergency_contact_person: yup.string().max(70).nullable().trim().label('Emergency Contact Person'),
                    emergency_contact_no: yup.string().max(15).nullable().trim().label('Emergency Contact No'),
                    card_id: yup.string().nullable().label('Card ID'),
                    nationality: yup.string().min(3).max(50).required().trim().label('Nationality'),
                    permanent_address: yup.string().min(4).max(150).required().trim().label('Permanent Address'),

                    email: yup.string().min(11).max(50).required().trim().email().label('Email'),
                    mobile: yup.string().min(8).max(15).required().label('Mobile No'),
                    nid: yup.number().positive().required().test('is-valid-nid', 'NID must be between 10 and 20 digits', (value) => {
                                const nidString = value.toString();
                                return nidString.length >= 10 && nidString.length <= 20;
                            }).label('NID'),
                    branch_id: yup.number().positive().integer().required().label('Branch ID.'),
                    department_id: yup.number().positive().integer().required().label('Department'),
                    designation_id: yup.number().positive().integer().required().label('Designation'),
                    employee_type_id: yup.number().positive().integer().required().label('Employee Type'),
                    gender_id: yup.number().positive().integer().required().label('Gender'),
                    marital_status_id: yup.number().positive().integer().required().label('Marital Status'),
                    religion_id: yup.number().positive().integer().required().label('Religion'),

                }),

            });

            const name = useField('name');
            const code = useField('code');
            const mobile = useField('mobile');
            const employee_type_id = useField('employee_type_id');
            const gender_id = useField('gender_id');
            const blood_group_id = useField('blood_group_id');
            const religion_id = useField('religion_id');
            const nid = useField('nid');
            const status = useField('status');
            const employee_id = useField('employee_id');
            const user_id = useField('user_id');
            const department_id = useField('department_id');
            const branch_id = useField("branch_id");
            const designation_id = useField('designation_id');
            const permanent_address = useField('permanent_address');
            const marital_status_id = useField('marital_status_id');
            const nationality = useField('nationality');
            nationality.value.value = 'Bangladeshi';
            const phone_residence = useField('phone_residence');
            const phone_office = useField('phone_office');
            const height = useField('height');
            const weight = useField('weight');
            const date_of_birth = useField('date_of_birth');
            const joining_date = useField('joining_date');
            const emergency_contact_person = useField('emergency_contact_person');
            const emergency_contact_no = useField('emergency_contact_no');
            const card_id = useField('card_id');
            const name_bangla = useField('name_bangla');
            const father_name = useField('father_name');
            const mother_name = useField('mother_name');
            const passport_no = useField('passport_no');
            const email = useField('email');
            const hod_approve_employee_id = useField('hod_approve_employee_id');
            const hr_approve_employee_id = useField('hr_approve_employee_id');
            const selectedImage  = ref(null);
            const errorMessages  = ref('');
            const loading  = ref('');
            const buttonText  = ref('');
            buttonText.value = 'Save';
            const store = useStore();
            const router = useRouter();
            const submit = handleSubmit((values) => {
                values.date_of_birth = formattedDate(date_of_birth.value.value);
                values.joining_date = formattedDate(joining_date.value.value);
                // Create a FormData object
                const formData = new FormData();
                // Append all form values to FormData
                Object.keys(values).forEach((key) => { formData.append(key, values[key] || '')});

                // Append the selected image to FormData
                if (selectedImage.value) {
                    formData.append('image', selectedImage.value); // 'logo' is the key for the file
                }
                formData.append('status', status.value.value ? 1 : 0);
                store.dispatch("saveUpdateEmployeeSetup", formData, { headers: { 'Content-Type': 'multipart/form-data' } })
                    .then((response) => {
                        buttonText.value = 'Save';
                        resetForm();
                        toast.success(response.data.message, {
                            timeout: 3000,
                        });
                        setTimeout(() => {
                            store.dispatch("getHrmEmployeeList").then(() => {
                                router.push({ path: "employee-list" });
                            });
                        }, 2000);
                    })
                    .catch((error) => {            
                        const backendErrors = error.response?.data?.errors;
                        if (backendErrors && typeof backendErrors === 'object') {
                            Object.values(backendErrors)
                                .flat()
                                .forEach(msg => toast.error(msg));
                        } else {
                            const msg = error.response?.data?.message || 'Failed to employee information';
                            toast.error(msg);
                        }
                        return false;      
                    })
            });
            
            return {
                submit,
                name,
                code,
                mobile,
                nid,
                employee_type_id,
                branch_id,
                gender_id,
                blood_group_id,
                religion_id,
                permanent_address,
                email,
                phone_residence,
                phone_office,
                height,
                weight,
                date_of_birth,
                joining_date,
                marital_status_id,
                nationality,
                emergency_contact_person,
                emergency_contact_no,
                card_id,
                name_bangla,
                father_name,
                mother_name,
                passport_no,
                status,
                errorMessages,
                selectedImage,
                employee_id,
                user_id,
                department_id,
                designation_id,
                hod_approve_employee_id,
                hr_approve_employee_id,
                buttonText,
                loading
            }
        },
        mounted() {
            console.log(this.$store.getters.getEditingHrmEmployee)
            if (this.$store.getters.getEditingHrmEmployee) {
                const employee = this.$store.getters.getEditingHrmEmployee;
                this.employee_id.value.value = employee.id;
                this.name.value.value = employee.name;
                this.code.value.value = employee.code || '';
                this.mobile.value.value = employee.mobile;
                this.nid.value.value = employee.nid;
                this.employee_type_id.value.value = employee.employee_type_id;
                this.user_id.value.value = employee.user_id;
                this.department_id.value.value = employee.department_id;
                this.branch_id.value.value = employee.branch_id;
                this.designation_id.value.value = employee.designation_id;
                this.gender_id.value.value = employee.gender_id;
                this.blood_group_id.value.value = employee.blood_group_id;
                this.religion_id.value.value = employee.religion_id;
                this.permanent_address.value.value = employee.permanent_address;
                this.email.value.value = employee.email;
                this.phone_residence.value.value = employee.phone_residence;
                this.phone_office.value.value = employee.phone_office;
                this.height.value.value = employee.height;
                this.weight.value.value = employee.weight;
                this.date_of_birth.value.value = employee.date_of_birth;
                this.joining_date.value.value = employee.joining_date;
                this.marital_status_id.value.value = employee.marital_status_id;
                this.nationality.value.value = employee.nationality;
                this.emergency_contact_person.value.value = employee.emergency_contact_person;
                this.emergency_contact_no.value.value = employee.emergency_contact_no;
                this.card_id.value.value = employee.card_id;
                this.name_bangla.value.value = employee.name_bangla;
                this.father_name.value.value = employee.father_name;
                this.mother_name.value.value = employee.mother_name;
                this.passport_no.value.value = employee.passport_no;
                this.hod_approve_employee_id.value.value = employee.hod_approve_employee_id || null;
                this.hr_approve_employee_id.value.value = employee.hr_approve_employee_id || null;
                this.status.value.value = employee?.status;

                this.buttonText = 'Update';
                return;

            } 
            this.status.value.value = 1;
        },  
        
        beforeUnmount() {
            this.$store.commit("UNSET_EDITING_HRM_EMPLOYEE_LIST");
        }
    }
</script>

<style scoped>
.v-card-title {
    height: 40px;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
}
</style>
